export const Card = ({ title, children, className = "" }) => (
  <section className={`bg-white rounded-2xl border border-slate-200/80 p-5 sm:p-6 shadow-sm ${className}`}>
    {title && <h2 className="text-base font-semibold text-slate-900 mb-4">{title}</h2>}
    {children}
  </section>
);

export const Label = ({ children }) => (
  <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">{children}</label>
);

export const inputCls = "w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-400 transition";

export const PrimaryButton = ({ children, className = "", ...p }) => (
  <button {...p} className={`bg-slate-900 hover:bg-slate-800 disabled:opacity-50 text-white px-5 py-2.5 rounded-xl font-medium text-sm transition-colors flex items-center justify-center gap-2 ${className}`}>
    {children}
  </button>
);
